export default "__VITE_ASSET__CIIXkKte__"